import axiosClient from "utils/api";
const URI = "/admin/users";

export const getUser = async (payload) => {
  const URL = `${URI}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
      params: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during Get user:", error);
    throw error;
  }
};

export const statusManageUser = async (payload) => {
  const { id, ...rest } = payload;
  const URL = `${URI}/${id}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "put",
      data: rest,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred status Manage user:", error);
    throw error;
  }
};

export const getUserDetail = async (payload) => {
  const URL = `${URI}/${payload.id}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during Get user detail:", error);
    throw error;
  }
};

export const getConnectionList = async (payload) => {
  const URL = "/admin/connection";
  try {
    const response = await axiosClient().request({
      url: URL,
      params: payload,
      method: "get",
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during Get connection list:", error);
    throw error;
  }
};